export default {
  accountInfo: (state) => state.accountInfo,
  logged: (state) => state.logged,
};
